import { render, staticRenderFns } from "./TabGeneralView.vue?vue&type=template&id=1f4c1655&scoped=true&lang=pug"
import script from "./TabGeneralView.vue?vue&type=script&lang=js"
export * from "./TabGeneralView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4c1655",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f4c1655')) {
      api.createRecord('1f4c1655', component.options)
    } else {
      api.reload('1f4c1655', component.options)
    }
    module.hot.accept("./TabGeneralView.vue?vue&type=template&id=1f4c1655&scoped=true&lang=pug", function () {
      api.rerender('1f4c1655', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tableau/datasource/TabGeneralView.vue"
export default component.exports